module.exports = __webpack_public_path__ + "img/cart-green.ead28651.png";